import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { LookAndLikeBannerClickedTrackingEvent, TrackingEventName } from "./tracking";

interface TrackLookAndLikeBannerClickedFunction {
  (): void;
}

interface UseTrackLookAndLikeBannerClickedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackLookAndLikeBannerClickedFunction {
  (agrs: UseTrackLookAndLikeBannerClickedFunctionArgs): TrackLookAndLikeBannerClickedFunction;
}

const useTrackLookAndLikeBannerClicked: UseTrackLookAndLikeBannerClickedFunction = ({
  country,
  segment,
  tradename,
  userId,
}) => {
  const emitUserEvent = useEmitUserEvent<LookAndLikeBannerClickedTrackingEvent>();

  const trackLookAndLikeBannerClicked: TrackLookAndLikeBannerClickedFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.LOOK_AND_LIKE_BANNER_CLICKED,
      eventCategory: TrackingEventCategory.LOOK_IN,
      store: country,
      section: "afterCheckout",
      segment,
      tradename,
      userId,
      userUuid: userId,
    });
  }, [country, emitUserEvent, segment, tradename, userId]);

  return trackLookAndLikeBannerClicked;
};

export { useTrackLookAndLikeBannerClicked };
